import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper
} from "@mui/material";
import { CookieItem } from "../cookieTypes";

interface CookieTableProps {
    cookies: CookieItem[];
    compact?: boolean;
}

export const CookieTable: React.FC<CookieTableProps> = ({ cookies, compact = false }) => {
    if (cookies.length === 0) return null;

    const table = (
        <Table size="small">
            <TableHead>
                <TableRow>
                    <TableCell><strong>Name</strong></TableCell>
                    <TableCell><strong>Anbieter</strong></TableCell>
                    <TableCell><strong>Zweck</strong></TableCell>
                    <TableCell><strong>Laufzeit</strong></TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {cookies.map((cookie, idx) => (
                    <TableRow key={idx}>
                        <TableCell>
                            <code style={{ fontSize: '0.85em' }}>
                                {cookie.name}
                            </code>
                        </TableCell>
                        <TableCell>{cookie.provider}</TableCell>
                        <TableCell>{cookie.purpose}</TableCell>
                        <TableCell>{cookie.duration}</TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );

    if (compact) {
        return <TableContainer>{table}</TableContainer>;
    }

    return (
        <TableContainer component={Paper} variant="outlined">
            {table}
        </TableContainer>
    );
};